import React, { useEffect, useState } from 'react';
import ModalSheet from '@boschebike/ebds-react/dist-esm/components/ModalSheet.js';
import useModal from '@boschebike/ebds-react/dist-esm/components/hooks/useModal.js';
import { getDodo } from '@boschebike/ebds-js/dist-esm/helpers/dodo.js';
import { hideModal } from '../stores/slices/modal-sheet.slice.js';
import { useDodoDispatch, useDodoSelector } from './DodoStoreProvider.js';

const ModalSheetWrapper = ({ customModals }) => {
  const dispatch = useDodoDispatch();
  const { modalSheetProps, dispatchModal, isHidden } = useModal({ customModals });
  // eslint-disable-next-line no-shadow
  const state = useDodoSelector((state) => state.modalSheet);

  useEffect(() => {
    dispatchModal(state);
  }, [state, dispatchModal]);

  useEffect(() => {
    if (isHidden) {
      dispatch(hideModal(null));
    }
  }, [dispatch, isHidden]);

  return <ModalSheet {...modalSheetProps} />;
};

export const ModalSheetProvider = () => {
  const [customModals, setCustomModals] = useState(null);
  useEffect(() => {
    getDodo().then((dodo) => {
      setCustomModals(dodo.ui.customModals());
    });
  });

  if (!customModals) {
    return null;
  }

  return <ModalSheetWrapper customModals={customModals} />;
};
